import { DEFAULT_REALM } from '@/constants/global';
import { HUB_API_PATH, RCU_PATH } from '@/constants/url';

export const getRealmFromUrl = (): string => {
  const hostname = window.location.hostname;

  const parts = hostname.split('.');

  // If no subdomain (like localhost) or if subdomain is www or srh, use srh
  if (parts.length < 2 || parts[0] === 'www' || parts[0] === DEFAULT_REALM) {
    return DEFAULT_REALM;
  }

  // Return the subdomain as realm
  return parts[0];
};

export const getApiUrl = (): string => {
  return `${window.location.origin}${HUB_API_PATH}`;
};
